import { NotBuilt } from '@/components/bits'

export function RightToWork() {
  return (
    <div className="screen">
      <NotBuilt title="Right to work register">
        The rules, the follow-up dates and the Home Office evidence types are built and running.
        The register screen is next: one row per person, with the evidence type, the date it was
        checked, who checked it, when it needs repeating, and whether a statutory excuse currently
        stands. Nothing has been recorded here yet, so at the moment the honest answer for every
        employee is no excuse.
      </NotBuilt>
    </div>
  )
}

export function Absence() {
  return (
    <div className="screen">
      <div className="callout" style={{ marginBottom: 20 }}>
        <strong>Designed, not built.</strong> The shape is settled: the request is raised in
        Planday, because that is the app people already clock in with; the alert lands here; the
        entitlement and every calculation are ours; approving writes the decision back. Holiday
        records have had to be kept for six years since 6 April 2026 and the liability is criminal,
        which is why the record has to be ours rather than a report we could lose access to.
      </div>
      <NotBuilt title="Absence inbox">
        Next steps are the entitlement engine (pro-rating on contracted hours, carry-over, bank
        holidays, the leave year) and the Planday absence endpoints. The screen is the easy half.
      </NotBuilt>
    </div>
  )
}

export function Starters() {
  return (
    <div className="screen">
      <NotBuilt title="Starters">
        Manual entry and CSV import first, here, then pushed to Planday. Recruit Genie comes later
        and lands in the same place. One thing worth knowing before the demo: creating an employee
        through the Planday API does not send them an invite, so somebody still has to do that by
        hand.
      </NotBuilt>
    </div>
  )
}

export function Audit() {
  return (
    <div className="screen">
      <NotBuilt title="Audit trail">
        Every write is already recorded append-only, and the record is read back afterwards whether
        the write succeeded or failed, so a failure is visible rather than silent. The screen to
        read it back is not built yet.
      </NotBuilt>
    </div>
  )
}
